import { combineReducers } from 'redux';
import base from './base';
import combo from './combo';

export default combineReducers({ base, combo });



// WEBPACK FOOTER //
// ./reducers/index.js